<template>
    <Popup ref="popup" :animation="'scale'" :shadowOpacity="0.7">
        <div class="payment-failure-cont" :style="landscapeScale < 1 ? { transform: `scale(${landscapeScale})` } : {}">
            <img class="payment-failure-bg" :src="_global.assetsRoot + '/common/pop_payment_bg.png'" />
            <div class="content">
                <div class="close t-r v-m">
                    <img class="v-m btn" :src="_global.assetsRoot + '/common/pop_btn_close.png'" @click.stop="close" />
                </div>
                <div class="title-section">
                    <img class="title-img" :src="_global.assetsRoot + `/common/payment_failure_title_${_i18n.locale}.png`" />
                </div>
                <div class="message-section">
                    <img class="failure-icon" :src="_global.assetsRoot + '/common/payment_icon_failure.png'" />
                    <div class="message-text">
                        <span class="description segoe">{{ failureReason }}</span>
                    </div>
                </div>
                <div class="buttons-section t-c">
                    <div class="btn retry-btn v-m" @click.stop="close">
                        <span class="beba v-m">{{ $t("message.tryAgain") }}</span>
                    </div>
                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue'

export default {
    props: {
        // Can be used to display different failure reasons
    },
    data() {
        return {
            failureReason: '',
            landscapeScale: 1
        }
    },
    methods: {
        show(reason = null) {
            this.failureReason = reason || this.$t("message.paymentFailureReason");
            if (window.innerWidth > window.innerHeight) {
                this.landscapeScale = 1;
            } else {
                this.landscapeScale = 1;
            }
            this.$refs.popup.show();
        },
        close() {
            this.$refs.popup.hide();
            this.$emit("onclose");
        }
    },
    components: { Popup }
}
</script>

<style lang="scss">
@import "../../assets/css/variables.scss";

.payment-failure-cont {
    position: relative;
    width: 593px;
    margin: 0 auto;
    transform-origin: center center;

    .payment-failure-bg {
        width: 100%;
    }

    .close {
        position: absolute;
        top: -1rem;
        right: -0.5rem;
        z-index: 10;
        width: 3rem;
        height: 3rem;

        img {
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
    }

    .content {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 2rem;

        .title-section {
            flex: 2;
            display: flex;
            align-items: center;
            justify-content: center;

            .title-img {
                width: 100%;
                position: absolute;
                top: 2rem;
                left: 0;
                z-index: 5;
                scale: .9;
            }

            .title {
                color: #FFFFFF;
                font-weight: bold;
                text-shadow:
                    -3px -3px 0 #2d2e81,
                    0px -3px 0 #2d2e81,
                    3px -3px 0 #2d2e81,
                    -3px  0px 0 #2d2e81,
                    3px  0px 0 #2d2e81,
                    -3px  3px 0 #2d2e81,
                    0px  3px 0 #2d2e81,
                    3px  3px 0 #2d2e81;
            }
        }

        .message-section {
            flex: 5;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 1rem;

            .failure-icon {
                width: 10rem;
                height: 8rem;
            }

            .message-text {
                text-align: center;

                .description {
                    display: block;
                    line-height: 1.5rem;
                    font-size: 1.2rem;
                    color: #FFFFFF;
                    font-weight: bold;
                    white-space: pre-line;
                    text-shadow:
                        -2px -2px 0 #2641bf,
                        0px -2px 0 #2641bf,
                        2px -2px 0 #2641bf,
                        -2px  0px 0 #2641bf,
                        2px  0px 0 #2641bf,
                        -2px  2px 0 #2641bf,
                        0px  2px 0 #2641bf,
                        2px  2px 0 #2641bf;
                }
            }
        }

        .buttons-section {
            flex: 3;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;

            .btn {
                display: inline-block;
                height: 4.2rem;
                line-height: 4rem;

                span {
                    color: #FFF;
                    font-size: 2.5rem;
                }
            }

            .retry-btn {
                width: 12rem;
                background: url($assetRoot + "/common/btn_buy.png") center no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
                color: #FFFFFF;
                font-weight: bold;
                text-shadow:
                    -1px -1px 0 #000000,
                    0px -1px 0 #000000,
                    1px -1px 0 #000000,
                    -1px  0px 0 #000000,
                    1px  0px 0 #000000,
                    -1px  1px 0 #000000,
                    0px  1px 0 #000000,
                    1px  1px 0 #000000;
            }
        }
    }
}

.mobile {
    .payment-failure-cont {
        width: 90%;

        .close {
            top: -1rem;
            right: -0.5rem;
            width: 4rem;
            height: 4rem;
        }

        .content {
            padding: 1rem;

            .title-section {
                .title {
                    font-size: 2.5rem;
                }
            }

            .message-section {
                gap: 0.8rem;

                .failure-icon {
                    width: 10rem;
                    height: 10rem;
                }

                .message-text {
                    .description {
                        font-size: 2rem;
                    }
                }
            }

            .buttons-section {
                .btn{
                    span{
                        font-size: 3rem;
                    }
                }
                .retry-btn {
                    font-size: 3rem;
                    width: 14rem;
                    height: 4.8rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PaymentFailure.vue